import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { registerLicense } from '@syncfusion/ej2-base';
import store from './store/index';
import './index.css';
import App from './components/App';

registerLicense("Ngo9BigBOggjHTQxAR8/V1NAaF5cWWJCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX5ccHRSQmVfUUd0WEpWYU0=");
const rootEl = document.getElementById('root');
const root = ReactDOM.createRoot(rootEl);

const basename = process.env.REACT_APP_BASENAME || '/skillz';

root.render(
    <Provider store={store} >
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter >
    </Provider>
);
